import React, { useEffect } from "react";
import { ErrorMessage } from "@hookform/error-message";

const Select = ({
  options,
  theme,
  name,
  setSelectedState,
  instruction,
  children,
  register,
  required,
  errors,
  changeFile,
  tabName,
  tabId,
  handleLinkForm,
  builder,
  linkedTabs,
  getValues,
}: any) => {
  const styles = {
    select: {
      lineHeight: `${theme?.to_rem("20px")}`,
      width: "100%",
      border: 0,
      borderBottom: `1px solid ${theme?.colors?.border_color}`,
      borderRadius: "0",
      padding: "8px",
      marginTop: "10px",
    },
  };

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const { value } = e.target;

    if (!handleLinkForm || !tabId || !builder?.id) return;
    const newValue =
      builder?.options?.find((opt: any) => opt?.option === value) || {};
    const option =
      builder?.options?.find((opt: any) => opt.id === newValue?.id) || {};

    const newBuilders =
      linkedTabs?.find((tab: any) => tab.id === option?.linkedToFormId)
        ?.builders || option?.linkedForm?.builders;

    handleLinkForm(tabId, newBuilders, builder.id);
  };

  const initialValue = getValues?.(name);

  useEffect(() => {
    if (name && getValues && initialValue) {
      handleChange({
        target: { value: initialValue },
      } as React.ChangeEvent<HTMLSelectElement>);
    }
  }, [initialValue]);

  return (
    <div style={{ marginBottom: "20px" }}>
      <select
        style={styles.select}
        {...register(name, {
          required: required ? `${instruction} is required` : false,
          onChange: (e: any) => {
            if (setSelectedState) {
              setSelectedState(e.target.value);
            }
            if (name === "documentName") {
              changeFile(e, tabName);
            }
            handleChange(e);
          },
        })}
      >
        <option value="">-- {instruction} --</option>
        {options
          ? options.map((data: any) => (
              <option
                value={data?.option || initialValue}
                key={JSON.stringify(data)}
              >
                {data.option}
              </option>
            ))
          : children}
      </select>
      <ErrorMessage
        errors={errors}
        name={name}
        as="span"
        className="error-form"
      />
    </div>
  );
};

export default Select;
